<template lang="pug">

  label(class="sosRadio" :class="{ 'sosRadio--checked': value === checked, 'sosRadio--disabled': disabled }" :for="id" :disabled="disabled")
    input(type="radio" :value="value" :checked="value === checked" @change="updateRadio" :id="id" :name="name" class="sosRadioInput")
    span.sosRadioInner
    span(v-if="!!label" class="sosRadioLabel") {{ label }}

</template>

<script>

  export default {
    name: 'SosRadio',
    props: {
      disabled: {
        type: Boolean,
        default: () => false,
      },
      checked: {
        type: String,
        default: () => false,
      },
      label: {
        type: String,
        default: () => '',
      },
      id: {
        type: String,
        required: true,
        default: () => '',
      },
      name: {
        type: String,
        required: true,
        default: () => '',
      },
      value: {
        type: String,
        required: true,
        default: () => '',
      },
    },

    methods: {
      updateRadio (event) {
        event.preventDefault()

        if (this.disabled) return false

        this.$emit('click', this.value)
      },
    },
  }

</script>

<style scoped lang="scss">

  .sosRadioInput {
    display: none;
  }

  .sosRadio {
    cursor: pointer;

    font-size: 0;

    input[type="checkbox"] {
      display: none;
    }

    .sosRadioInner {
      transition-property: background-color;
      transition-duration: 150ms;

      position: relative;

      display: inline-block;
      vertical-align: middle;
      width: 18px;
      height: 18px;
      border: 1px solid #e54245;
      border-radius: 100%;
      background-color: transparent;

      &::before,
      &::after {
        transition-property: background-color;
        transition-duration: 150ms;

        content: "";

        position: absolute;
        width: 2px;
        background-color: transparent;
      }

      &::before {
        top: 7px;
        left: 4px;

        height: 6px;
        transform: rotate(-45deg);
      }

      &::after {
        top: 3px;
        left: 9px;

        height: 10px;
        transform: rotate(40deg);
      }
    }

    .sosRadioLabel {
      display: inline-block;
      vertical-align: middle;
      // padding-left: 4px;
      padding-left: 5px;

      font-size: 14px;
      line-height: 14px;
      // font-size: 16px;
      // line-height: 20px;

      user-select: none;
    }

    &.sosRadio--checked {
      .sosRadioInner {
        background-color: #e54245;

        &:before,
        &:after {
          background-color: #FFFFFF;
        }
      }
    }

    &.sosRadio--disabled {
      cursor: not-allowed;

      .sosRadioInner {
        background-color: #DDDDDD;
        border: 1px solid #AAAAAA;
      }

      .sosRadioLabel {
        color: #888888;
      }

      &.sosRadio--checked {
        .sosRadioInner {
          &:before,
          &:after {
            background-color: #999999;
          }
        }
      }
    }
  }

</style>
